import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { take, finalize } from 'rxjs/operators';

import { RewardService } from '../../../rewards/services/reward.service';
import { FlashService } from '../flash/services/flash.service';
import { parseCsv } from 'app/shared/utils/csv-to-array';

@Component({
  selector: 'app-dialog-import-rewards',
  templateUrl: './dialog-import-rewards.component.html',
  styleUrls: ['./dialog-import-rewards.component.sass']
})
export class DialogImportRewardsComponent implements OnInit {
  selectedFile: any = {};
  csvErrors = [];
  uploading = false;

  constructor(
    public dialogRef: MatDialogRef<DialogImportRewardsComponent>,
    public rewardService: RewardService,
    private flashService: FlashService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
  }

  onCsvFileSelected(uploaded) {
    this.csvErrors = [];

    const lines = parseCsv(uploaded.file.content);

    lines.forEach((line, i) => {
      if (i === 0 && (line[0] !== 'consumer_id' || line[1] !== 'amount' || line[2] !== 'reward_name')) {
        return this.csvErrors.push({
          line: 'Header',
          content: line.join(';'),
        });
      }

      if (i !== 0 && (
            !line[0].trim()
        ||  !line[1].trim().match(/^\d+(\.\d{1,2})?$/)
        ||  !line[2]
      )) {
        return this.csvErrors.push({
          line: i + 1,
          content: line.join(';'),
        });
      }
    });

    if (!this.csvErrors.length) {
      this.upload(uploaded);
    }
  }

  onStartAgain() {
    this.csvErrors = [];
  }

  onCancel() {
    this.dialogRef.close(false);
  }

  upload(file: any) {
    this.uploading = true;

    this.rewardService.upload(file.raw)
      .pipe(
        take(1),
        finalize(() => {
          this.uploading = false;
        })
      )
      .subscribe(
        (response) => {
          this.csvErrors = [];

          if (!this.csvErrors.length) {
            this.flashService.success('rewards.dialog.import.form.success');
            this.dialogRef.close(true);
          }
        },
        (error) => {
          alert('Import error ' + error.status);
        }
    );
  }
}
